// Manage Edit Realms
import { manageEditRealms, manageEditRealmsConfig } from './manage.editRealms'

export default function editRealmRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(manageEditRealms, manageEditRealmsConfig)
}
